/**
 * Banner enum for supported store brands
 * Represents different retail chains in the application
 */
export enum Banner {
  SHOPRITE = 'shoprite',
  FRESHGROCER = 'freshgrocer',
  PRICERITE = 'pricerite',
  DEARBORN = 'dearborn',
  FAIRWAY = 'fairway',
  GOURMETGARAGE = 'gourmetgarage',
  DIBRUNO = 'dibruno',
}

/**
 * Banner display information interface
 */
export interface BannerInfo {
  readonly organization: string;
  readonly authClientId?: string; // Auth0 Client ID for authentication
  readonly logoUrl: string; // URL for the logo image
  readonly xSiteHost?: string; // Optional cross-site host for API calls
  readonly primaryColor?: string;
  readonly cookieDomain?: string;
  readonly faviconUrl?: string;
  readonly title?: string;
}

/**
 * Comprehensive banner configuration with metadata
 */
export const BANNER_CONFIG: Record<Banner, BannerInfo> = {
  [Banner.SHOPRITE]: {
    organization: process.env['SR_OKTA_ORGID'] || '',
    authClientId: process.env['SR_AUTH0_CLIENT_ID'] || '',
    logoUrl: 'shoprite/logo.png',
    xSiteHost: process.env['SR_X_SITE_HOST'] || '',
    faviconUrl: 'shoprite/favicon.ico',
    title: 'ShopRite',
  },
  [Banner.FRESHGROCER]: {
    organization: process.env['FG_OKTA_ORGID'] || '',
    authClientId: process.env['FG_AUTH0_CLIENT_ID'] || '',
    logoUrl: 'freshgrocer/logo.png',
    xSiteHost: process.env['FG_X_SITE_HOST'] || '',
    faviconUrl: 'freshgrocer/favicon.ico',
    title: 'The Fresh Grocer',
  },
  [Banner.PRICERITE]: {
    organization: process.env['PR_OKTA_ORGID'] || '',
    authClientId: process.env['PR_AUTH0_CLIENT_ID'] || '',
    logoUrl: 'pricerite/logo.png',
    xSiteHost: process.env['PR_X_SITE_HOST'] || '',
    faviconUrl: 'pricerite/favicon.ico',
    title: 'PriceRite Marketplace',
  },
  [Banner.DEARBORN]: {
    organization: process.env['DB_OKTA_ORGID'] || '',
    authClientId: process.env['DB_AUTH0_CLIENT_ID'] || '',
    logoUrl: 'dearborn/logo.png',
    xSiteHost: process.env['DB_X_SITE_HOST'] || '',
    faviconUrl: 'dearborn/favicon.ico',
    title: 'Dearborn Market',
  },
  [Banner.FAIRWAY]: {
    organization: process.env['FW_OKTA_ORGID'] || '',
    authClientId: process.env['FW_AUTH0_CLIENT_ID'] || '',
    logoUrl: 'fairway/logo.png',
    xSiteHost: process.env['FW_X_SITE_HOST'] || '',
    faviconUrl: 'fairway/favicon.ico',
    title: 'Fairway Market',
  },
  [Banner.GOURMETGARAGE]: {
    organization: process.env['GG_OKTA_ORGID'] || '',
    authClientId: process.env['GG_AUTH0_CLIENT_ID'] || '',
    logoUrl: 'gourmetgarage/logo.png',
    xSiteHost: process.env['GG_X_SITE_HOST'] || '',
    faviconUrl: 'gourmetgarage/favicon.ico',
    title: 'Gourmet Garage',
  },
  [Banner.DIBRUNO]: {
    organization: process.env['DI_OKTA_ORGID'] || '',
    authClientId: process.env['DI_AUTH0_CLIENT_ID'] || '',
    logoUrl: 'dibruno/logo.png',
    xSiteHost: process.env['DI_X_SITE_HOST'] || '',
    faviconUrl: 'dibruno/favicon.ico',
    title: 'Di Bruno Bros',
  },
} as const;
